// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackAddAllItemsAndCheckoutParameters extends TrackEventBaseParameters {}

const trackAddAllItemsAndCheckout = (
    parameters: TrackAddAllItemsAndCheckoutParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "add_all_items_and_checkout", ...parameters }, options);
};

export default trackAddAllItemsAndCheckout;
